// extracted by mini-css-extract-plugin
module.exports = {"modal":"campaigns-details_modal__fxrR0"};